import React from "react";
import { Skeleton, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { PATH } from "../constant/path";
import { useGetMyApprovals } from "../hooks/get-my-approvals";
import { getStatus } from "../../../human-organization/summary-employee-request/utils/get-status";
import { useSelector } from "../../../../../store/store";

export const MyApprovals: React.FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetMyApprovals();

  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const columns: ColumnsType<any> = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render(value, record, index) {
        return getDDMMYYYFormat(record?.createdDateTime);
      },
    },
    {
      title: "Người tạo",
      dataIndex: "createdBy",
      key: "createdBy",
      render(value, record, index) {
        return record?.createdBy?.user?.displayName;
      },
    },
    {
      title: "Yêu cầu",
      dataIndex: "type",
      key: "type",
      render(value, record, index) {
        return <span className="flag warning">Yêu cầu</span>;
      },
    },
    {
      title: "Cơ quan/đơn vị",
      dataIndex: "eDepartment",
      key: "eDepartment",
      render(value, record, index) {
        return record?.fields?.eDepartment;
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render(value, record, index) {
        const status = getStatus({
          currentUser: currentUserName,
          requestStatus: record.fields.eRequestStatus,
          steps: [
            {
              status: record.fields.eApprovedStatus,
              approver: record.fields.eApprovedBy,
            },
            {
              status: record.fields.eApprovedByITLeadStatus,
              approver: record.fields.eApprovedByITLead,
            },
          ],
        });

        return <ApprovalStatus status={status} />;
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "Download",
      key: "Download",
      render(value, record, index) {
        return (
          <Button>
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        );
      },
    },
  ];

  if (isLoading) return <Skeleton />;

  return (
    <Table
      rowClassName="cursor-pointer"
      columns={columns}
      dataSource={data}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            history.push(PATH.DETAIL.replace(":id", record.id));
          },
        };
      }}
    />
  );
};
